/* eslint-disable */
const limitDecimals = function (value, limit) {
  const reg = new RegExp('^(\\-)*(\\d+)\\.(\\d{' + limit + '}).*$');
  if(typeof value === 'string') {
      return !isNaN(Number(value)) ? value.replace(reg, '$1$2.$3') : value
  } else if (typeof value === 'number') {
      return !isNaN(value) ? String(value).replace(reg, '$1$2.$3') : value
  }
  else {
      return value
  }
};
export default limitDecimals


// WEBPACK FOOTER //
// ./src/utils/limitDecimals.js